<ng-container *ngFor="let video of videoLinks"
  ><smart-fix-video-player
    [videoUrl]="video"
    class="video-preview"
  ></smart-fix-video-player>
</ng-container>
